<template>
  <SAIInput
    :value="value"
    v-bind="$attrs"
    :error="error"
    :type="showPassword ? 'text' : 'password'"
    class="password-input"
    :placeholder="placeholder"
    :class="['col-grow q-mt-sm password-input', { 'input-focused': focused }]"
    @input="(val) => $emit('input', val)"
    @focus="focused = true"
    @blur="focused = false"
  >
    <template v-slot:prepend>
      <QIcon
        class="q-mr-xs"
        color="grey-9"
        size="22px"
        name="eva-lock-outline"
      />
    </template>
    <template v-slot:after>
      <div
        :class="[
          'show-hide full-height row items-center',
          { 'input-focused': focused },
          { 'input-error': error }
        ]"
        @mousedown.prevent
        @click="updateShowPassword"
      >
        <p class="text-body2 text-weight-medium full-width text-right">
          {{ showPassword ? 'Hide' : 'Show' }}
        </p>
      </div>
    </template>
  </SAIInput>
</template>

<script>
import { QIcon } from 'quasar';

export default {
  name: 'SAIPasswordInput',
  data() {
    return {
      focused: false
    };
  },
  props: {
    value: {
      type: undefined
    },
    showPassword: Boolean,
    error: Boolean,
    placeholder: {
      type: String,
      default: 'Enter Password'
    }
  },
  methods: {
    updateShowPassword() {
      this.$emit('update:showPassword', !this.showPassword);
    }
  },
  components: {
    SAIInput: () => import('../sai-input'),
    QIcon
  }
};
</script>

<style lang="sass" scoped>
.password-input::v-deep
  .q-field__after
    padding-left: 0

  .q-field__control
    border-top-right-radius: 0
    border-bottom-right-radius: 0
    padding-right: 8px !important

  &.input-focused
    .q-field__control
      border-right: none

.show-hide
  cursor: pointer
  width: 48px
  background: $primary-light
  padding-right: 12px
  border: 1px solid transparent
  border-top-right-radius: 4px
  border-bottom-right-radius: 4px
  color: $primary


  &.input-error
    color: $negative
    background: $negative-light

  &.input-focused
    border: 1px solid $primary
    border-left: none

  &.input-focused.input-error
    border: 1px solid $negative
    border-left: none
</style>
